import React from 'react';
import { useT } from '../../../../../features/src/i18n/index';
import { Type } from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';
import { TRACK_CAT } from '../constants';
import {
  FooterTextLink,
  FooterTextLinkType,
} from '../components/FooterTextLink';

const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;

type CreatorToolsLink = FooterTextLinkType & { label: string };

export const CreatorTools = () => {
  const t = useT();
  const links: CreatorToolsLink[] = [
    {
      href: 'https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination',
      track: [TRACK_CAT, 'Creator Tools - Soundtrap'],
      dataTestId: 'footer-soundtrap',
      label: 'Soundtrap',
      external: true,
    },
    {
      href: 'https://podcasters.spotify.com/?utm_source=artists.spotify.com',
      track: [TRACK_CAT, 'Creator Tools - Spotify for Podcasters'],
      dataTestId: 'footer-s4p',
      label: 'Spotify for Podcasters',
      external: true,
    },
    {
      href: 'https://noteable.spotify.com/?utm_source=artists.spotify.com',
      track: [TRACK_CAT, 'Creator Tools - Noteable'],
      dataTestId: 'footer-spa',
      label: 'Noteable',
      external: true,
    },
  ];
  return (
    <>
      <Type variant="finaleBold" semanticColor="textBase">
        {t('FRODOR_d0bb36', 'Creator tools', '').toUpperCase()}
      </Type>
      <LinkList>
        {links.map(link => {
          return (
            <FooterTextLink key={link.label} {...link}>
              {link.label}
            </FooterTextLink>
          );
        })}
      </LinkList>
    </>
  );
};
